import React, { Component } from 'react'
import './ConfirmationMessage.scss';


export interface ConfirmationMessageProps {
  name?: string;
  variant?: string
}

export interface ConfirmationMessageState {

}


class ConfirmationMessage extends React.Component<ConfirmationMessageProps, ConfirmationMessageState> {

render(){

  return(


  <aside className={`confirmation-message ${this.props.variant}`}>
      <div className="confirmation-message-content">
          {this.props.name ? <p>{this.props.name} is preparing your quote</p> : <p>Your quote is ready</p>}
      </div>
      <div className="righticon">
          {<img src={require("../../../assets/images/round_check_white_18dp.png")} />}
      </div>
  </aside>

)
}
}

export default ConfirmationMessage;
